// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2ANIv","alert":"SettungsInbox_alert__2q3on"};